import {faPlus} from "@fortawesome/pro-solid-svg-icons/faPlus";
import {BatchMailItemType,} from "@twigsby/client-data/lib/Types/ForwardingBatchTypes";
import {
    Button,
    Card,
    CardLayoutType,
    ColourSolid,
} from "@twigsby/frontend-framework";
import {GetArrayIndexByKeyValue} from "@twigsby/helpers";
import React, {useEffect, useState} from "react";
import {useForwardingBatchProvider} from "../../../Providers/ForwardingBatchProvider";
import {BatchMailItemEntriesType, RenderBatchSectionType} from "../../../Types/ForwardingBatchTypes";
import {BatchMailItemEntry} from "../Controls/BatchMailItemEntry";
import {SearchMailItemsForBatchModal} from "../Modals/SearchMailItemsForBatchModal";

const BatchMailItems = (props: RenderBatchSectionType) => {
    const {
        currentBatchData,
        AddMailItemToBatch,
        RemoveMailItemFromBatch
    } = useForwardingBatchProvider();

    const [ mailItemSearchOpen, setMailItemSearchOpen ] = useState<boolean>(false);
    const [ selectedBatchMailUuids, setSelectedBatchMailUuids ] = useState<Array<string>>(currentBatchData ? currentBatchData?.items.map((item) => item.mailUuid) : []);

    useEffect(() => {
        if(currentBatchData) {
            setSelectedBatchMailUuids(currentBatchData?.items.map((item) => item.mailUuid))
        }
    }, [currentBatchData]);

    const HandleAddMailItems = (selectedMailItems: Array<BatchMailItemType>) => {
        const mailUuids: Array<string> = selectedMailItems.map((item) => item.mailUuid);

        setMailItemSearchOpen(false);

        setSelectedBatchMailUuids(selectedBatchMailUuids ? [...selectedBatchMailUuids, ...mailUuids] : mailUuids);

        if(currentBatchData?.batchId) {
            AddMailItemToBatch(mailUuids, selectedMailItems);
        }
    }

    const HandleRemoveMailItem = (mailUuid: string) => {
        const mailUuids: Array<string> = selectedBatchMailUuids ? [...selectedBatchMailUuids] : [];
        mailUuids.splice(mailUuids.indexOf(mailUuid), 1);

        setSelectedBatchMailUuids(mailUuids);

        if(currentBatchData?.batchId) {
            RemoveMailItemFromBatch(mailUuid);
        }
    }

    if(props.complete) return <BatchMailItemsComplete {...props} />;

    return (
        <div>
            <h5 className={'mb-xs'}>{props.complete ? props.section.name : `Step ${props.sectionIndex}: ${props.section.name}`}</h5>
            <p>Please ensure you tell us about everything your letters/parcels contain. You can add additional
                rows using the "Add Contents" button</p>
            <p>If the value of any individual item in your batch is above £5000.00, please contact our Mail-room
                        Forwarding team.</p>

            <div className={'mb-md'}>
                <BatchMailItemEntries {...props} removeMailItemCallback={HandleRemoveMailItem} />
            </div>

            <Button
                title={'Add Mail Item'}
                icon={faPlus}
                colour={ColourSolid.Primary}
                fullWidth={true}
                onClick={() => setMailItemSearchOpen(true)}
                disabled={props.readOnly}
            />

            <SearchMailItemsForBatchModal
                isOpen={mailItemSearchOpen}
                batchMailUuids={selectedBatchMailUuids}
                closeCallback={() => setMailItemSearchOpen(false)}
                actionedCallback={(e: Array<BatchMailItemType>) => HandleAddMailItems(e) }
            />
        </div>
    )
}

const BatchMailItemsComplete = (props: RenderBatchSectionType) => {
    return (
        <div>
            <h5 className={'mb-xs'}>{props.complete ? props.section.name : `Step ${props.sectionIndex}: ${props.section.name}`}</h5>

            <div className={'mb-md'}>
                <BatchMailItemEntries {...props} removeMailItemCallback={() => null}/>
            </div>
        </div>
    )
}

const BatchMailItemEntries = (props: BatchMailItemEntriesType) => {
    const { currentBatchData } = useForwardingBatchProvider();

    return (
        <>
            {currentBatchData?.splits && currentBatchData?.splits.map((split, index) =>
                <div className={'forwarding-batch-split-items-wrapper'}>
                    <Card
                        headerOptions={{
                            title: `Shipment ${index + 1}`,
                            action:
                                split.externalTrackingUrl && (
                                    <Button
                                        title={'View Tracking'}
                                        actionLink={{
                                            title: 'View Tracking',
                                            url: split.externalTrackingUrl,
                                            target: '_blank'
                                        }}
                                        colour={ColourSolid.Primary}
                                    />
                                )
                        }}
                        emptyBody={true}
                        type={CardLayoutType.Default}
                    >
                        {split.mailItems.map((splitItem, index) => {
                            if (splitItem.trackingId) {
                                const mailItem = currentBatchData?.items[GetArrayIndexByKeyValue(currentBatchData?.items, 'trackingId', splitItem.trackingId)];

                                if(!mailItem) {
                                    console.log(`no mail item for split? ${splitItem.trackingId}`);
                                    return (
                                        <div className={`forwarding-batch-item ${props.readOnly ? 'batch-read-only' : ''}`}>
                                            <div className='forwarding-batch-item-entry-title'>
                                                {splitItem.trackingId}
                                            </div>
                                        </div>
                                    )
                                }

                                return (
                                    <BatchMailItemEntry
                                        key={`splitItem${splitItem.trackingId}`}
                                        mailItemIndex={index}
                                        trackingId={mailItem.trackingId}
                                        mailUuid={mailItem.mailUuid}
                                        descriptions={mailItem.descriptions}
                                        files={mailItem.files}
                                        mailType={mailItem.mailType}
                                        readOnly={props.readOnly || props.complete}

                                        removable={currentBatchData?.items.length > 1}
                                        removeMailItem={() => props.removeMailItemCallback(mailItem.mailUuid)}
                                    />
                                );
                            }
                        })}
                    </Card>
                </div>
            )}

            {!currentBatchData?.splits && (
                <div className={'forwarding-batch-item-mail-items'}>
                    {currentBatchData?.items.map((mailItem: any, index) =>
                        <BatchMailItemEntry
                            key={mailItem.id}

                            mailItemIndex={index}
                            trackingId={mailItem.trackingId}
                            mailUuid={mailItem.mailUuid}
                            descriptions={mailItem.descriptions}
                            files={mailItem.files}
                            mailType={mailItem.mailType}
                            readOnly={props.readOnly || props.complete}

                            removable={currentBatchData?.items.length > 1}
                            removeMailItem={() => props.removeMailItemCallback(mailItem.mailUuid)}
                        />
                    )}
                </div>
            )}
        </>
    )
}

export {BatchMailItems}
